<section class="col-xs-12 col-sm-12 financial_invoices">
  @if (isLoading) {
    <div class="loading">
      <div class="loading_txt">
        <div class="load_txt">Loading</div>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  }
  @if (!isLoading) {
    <div>
      <div class="col-xs-12 col-sm-12 financial_headerparent">
        <div class="col-xs-12 col-sm-12 no-padding financial_invoiceheader">
          {{"financialDashboard.invoicetitle" | cxTranslate}}
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 financial_invoicebtns">
        <div
          class="col-xs-12 col-sm-12 financial_invoicebtn"
          id="financial_invoicebtn-1"
          (click)="openinvoice()"
          [ngClass]="openinvoiceflag ? 'active' : ''"
          >
          <div class="col-xs-12 col-sm-12 financial_invoicebtnParent">
            <!-- total invoice changes -->
            <div class="financial_invoicebtnheader">{{"financialDashboard.openinvoicetitle" | cxTranslate}}</div>
            @if (overdueflag == true) {
              <span class="financial_alert">
                <img
                  src="assets/images/exclamation-mark.png"
                  class="financial_alertImg"
                  /> </span
                  >
              }
            </div>
            <div
              class="col-sm-12 d-md-none d-lg-none financial_alert-msgOpen mobile_alert"
              >
              {{ financialresponse?.overdueInvoiceSeasonText }}
            </div>
          </div>
          <div
            class="col-xs-12 col-sm-12 financial_invoicebtn"
            id="financial_invoicebtn-2"
            (click)="paidinvoice()"
            [ngClass]="paidinvoiceflag ? 'active' : ''"
            >
            <div class="col-xs-12 col-sm-12 financial_invoicebtnheader">
              {{"financialDashboard.paidinvoicetitle" | cxTranslate}}
            </div>
            <div
              class="col-sm-12 d-md-none d-lg-none financial_alert-msgOpen mobile_alert"
              [innerHtml]="financialresponse?.paidInvoicesText"
            ></div>
          </div>
        </div>
        <div
          class="financial_dropdown mob_season_dropdown d-lg-none col-sm-12 no-padding"
          [ngClass]="toggleseason ? 'open' : ''"
          >
          <!-- total invoice changes -->
          <div class="button" (click)="openseason()">
            <!-- <span *ngIf="financialresponse?.currentSelectedSeason;else defaultseason"> -->
            @if (viewingkey == true) {
              <span
                class="seasonyear mob_Seasonyear_True"
                >{{ viewingseason }}&nbsp;{{"financialDashboard.invoicetitle" | cxTranslate}}
              </span>
            }
            @if (viewingkey == false) {
              <span class="seasonyear"
                >{{ viewingseason }}&nbsp;{{"financialDashboard.invoicetitle" | cxTranslate}}
              </span>
            }
          </div>
          <ul class="select-list" [ngClass]="toggleseason ? 'open' : ''">
            @for (season of financialresponse?.overdueinvoiceseason; track season) {
              <li
                class="clsAnchor"
                >
                @if (viewingseason != season.key) {
                  @if (season.value == true) {
                    <span
                      class="seasonyear mob_Season_List_True"
                      (click)="seasonchangeclick(season.key)"
                      >{{ season.key }}&nbsp;{{"financialDashboard.invoicetitle" | cxTranslate}}
                    </span>
                  }
                  @if (season.value == false) {
                    <span
                      class="seasonyear"
                      (click)="seasonchangeclick(season.key)"
                      >{{ season.key }}&nbsp;{{"financialDashboard.invoicetitle" | cxTranslate}}
                    </span>
                  }
                }
              </li>
            }
          </ul>
        </div>
        <div
          class="col-xs-12 col-sm-12 col-lg-12 col-md-12 opensection"
          [ngClass]="openinvoiceflag ? 'open' : ''"
          >
          @if (overdueflagtext) {
            <div
              class="col-sm-12 d-md-block d-lg-block d-none financial_alert-msg financial_alert-msgOpen"
              >
              {{ financialresponse?.overdueInvoiceSeasonText }}
            </div>
          }
          <div
            class="col-xs-12 col-sm-12 financial_invoicetable"
            id="financial_invoicetable1"
            >
            <div
              class="financial_invoicetableheader col-xs-12 col-sm-12 col-md-12 col-lg-5"
              >
              {{"financialDashboard.openinvoicetitle" | cxTranslate}}
            </div>
            <!-- total invoice changes -->
            <div
              class="financial_dropdown margin-B20 d-none d-lg-block"
              [ngClass]="toggleseason ? 'open' : ''"
              >
              <!-- total invoice changes -->
              <div class="button" (click)="openseason()">
                <!-- <span *ngIf="financialresponse?.currentSelectedSeason;else defaultseason"> -->
                @if (viewingkey == true) {
                  <span
                    class="seasonyear seasonyear_True"
                    >{{ viewingseason }}&nbsp;{{"financialDashboard.invoicetitle" | cxTranslate}}
                  </span>
                }
                @if (viewingkey == false) {
                  <span class="seasonyear"
                    >{{ viewingseason }}&nbsp;{{"financialDashboard.invoicetitle" | cxTranslate}}
                  </span>
                }
              </div>
              <ul class="select-list" [ngClass]="toggleseason ? 'open' : ''">
                @for (season of financialresponse?.overdueinvoiceseason; track season) {
                  <li
                    class="clsAnchor"
                    >
                    @if (viewingseason != season.key) {
                      @if (season.value == true) {
                        <span
                          class="seasonyear season_List_True"
                          (click)="seasonchangeclick(season.key)"
                          >{{ season.key }}&nbsp;{{"financialDashboard.invoicetitle" | cxTranslate}}
                        </span>
                      }
                      @if (season.value == false) {
                        <span
                          class="seasonyear"
                          (click)="seasonchangeclick(season.key)"
                          >{{ season.key }}&nbsp;{{"financialDashboard.invoicetitle" | cxTranslate}}
                        </span>
                      }
                    }
                  </li>
                }
              </ul>
            </div>
            <!-- total invoice changes -->
            <div class="financial_invoicetabledetail">
              <div class="financial_invoicetabledetail1">
                <div
                  class="col-xs-12 col-sm-12 ck-button no-padding"
              [ngClass]="
                financialresponse.seqirusFinancialDashboardData?.statuses
                  .overdue == 0
                  ? 'inactive_status'
                  : ''
              "
                  >
                  <label>
                    <input
                      type="checkbox"
                      class="status"
                      name="name"
                      value="Overdue"
                      (click)="filteropen($event, 'overdue')"
                      />
                      <span
                        class="financial_invoiceoverdueNo financial_invoiceNo call_status"
                        >{{
                        financialresponse.seqirusFinancialDashboardData?.statuses
                        .overdue | number : "2.0-0"
                        }}</span
                        >
                        <span class="financial_invoiceoverdueText">{{"financialDashboard.overduetext" | cxTranslate}}</span>
                        @if (
                          financialresponse?.seqirusFinancialDashboardData?.statuses
                          .overdue > 0
                          ) {
                          <span
                            class="financial_alert"
                            >
                            <img
                              src="assets/images/exclamation-mark.png"
                              class="financial_alertImg"
                              />
                            </span>
                          }
                        </label>
                      </div>
                      <div
                        class="col-xs-12 col-sm-12 ck-button no-padding"
              [ngClass]="
                financialresponse?.seqirusFinancialDashboardData?.statuses
                  .dueSoon == 0
                  ? 'inactive_status'
                  : ''
              "
                        >
                        <label>
                          <input
                            type="checkbox"
                            class="status"
                            name="name"
                            value="Due Soon"
                            (click)="filteropen($event, 'duespon')"
                            />
                            <span
                              class="financial_invoiceduesoonNo financial_invoiceNo call_status"
                              >{{
                              financialresponse?.seqirusFinancialDashboardData?.statuses
                              .dueSoon | number : "2.0-0"
                              }}</span
                              >
                              <span class="financial_invoiceduesoonText"
                                >{{"financialDashboard.duesoontxt" | cxTranslate}}</span
                                >
                              </label>
                            </div>
                            <div
                              class="col-xs-12 col-sm-12 ck-button no-padding"
              [ngClass]="
                financialresponse?.seqirusFinancialDashboardData?.statuses
                  .unpaid == 0
                  ? 'inactive_status'
                  : ''
              "
                              >
                              <label>
                                <input
                                  type="checkbox"
                                  class="status"
                                  name="name"
                                  value="Open"
                                  (click)="filteropen($event, 'open')"
                                  />
                                  <span
                                    class="financial_invoiceunpaidNo financial_invoiceNo call_status"
                                    >{{
                                    financialresponse?.seqirusFinancialDashboardData?.statuses
                                    .unpaid | number : "2.0-0"
                                    }}</span
                                    >
                                    <span class="financial_invoiceunpaidText">{{"financialDashboard.opentxt" | cxTranslate}}</span>
                                  </label>
                                </div>
                              </div>
                              @if (opendata.data.length > 0) {
                                <div
                                  class="financial_invoicetabledetail2 desktop_Financial_invoicetabledetail2"
                                  >
                                  <table
                                    mat-table
                                    [dataSource]="opendata"
                                    class="mat-elevation-z8 financial_table"
                                    >
                                    <ng-container matColumnDef="invoiceNumber">
                                      <th mat-header-cell *matHeaderCellDef>{{"financialDashboard.invoicenolabel" | cxTranslate}}</th>
                                      <td mat-cell *matCellDef="let row">{{ row.invoiceNumber }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="status">
                                      <th mat-header-cell *matHeaderCellDef>{{"financialDashboard.statuslabel" | cxTranslate}}</th>
                                      <td mat-cell *matCellDef="let row">{{ row.status }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="amountDue">
                                      <th mat-header-cell *matHeaderCellDef>{{"financialDashboard.remainingBaltxt" | cxTranslate}}</th>
                                      <td mat-cell *matCellDef="let row">
                                        ${{ row.amountDue | number : "1.2-2" }}
                                      </td>
                                    </ng-container>
                                    <ng-container matColumnDef="amount">
                                      <th mat-header-cell *matHeaderCellDef>{{"financialDashboard.totalinvcostlabel" | cxTranslate}}</th>
                                      <td mat-cell *matCellDef="let row">
                                        ${{ row.amount | number : "1.2-2" }}
                                      </td>
                                    </ng-container>
                                    <ng-container matColumnDef="invoiceDate">
                                      <th mat-header-cell *matHeaderCellDef>{{"financialDashboard.invoiceDate" | cxTranslate}}</th>
                                      <td mat-cell *matCellDef="let row">{{ row.invoiceDate }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="dueDate">
                                      <th mat-header-cell *matHeaderCellDef>{{"financialDashboard.dueDate" | cxTranslate}}</th>
                                      <td mat-cell *matCellDef="let row">{{ row.dueDate }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="selected">
                                      <th mat-header-cell *matHeaderCellDef></th>
                                      <td mat-cell *matCellDef="let row">
                                        <a
                                          class="anchorlink"
                                          [routerLink]="'/financial-dashboard/all-invoices'"
                    [queryParams]="{
                      invoice: row.invoiceNumber,
                      season: viewingseason
                    }"
                                          ><span>{{"financialDashboard.viewinvoice" | cxTranslate}}</span>
                                          <div class="global_blackarrow"></div
                                          ></a>
                                        </td>
                                      </ng-container>
                                      <!-- Header and Row Declarations -->
                                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                      <tr
                                        mat-row
                                        id="{{ row.invoiceNumber }}"
                                        *matRowDef="let row; columns: displayedColumns"
                                      ></tr>
                                    </table>
                                  </div>
                                }
                                <!-- moblie table for invoice start's here -->
                                <div
                                  class="financial_invoicetabledetail2 financial_openinvoiceMobiletable-1"
                                  >
                                  <table
                                    mat-table
                                    [dataSource]="opendata"
                                    class="mat-elevation-z8 financial_table"
                                    >
                                    <ng-container matColumnDef="combined">
                                      <th
                                        class="odertableheader d-none"
                                        mat-header-cell
                                        *matHeaderCellDef
                                        >
                                        order Data
                                      </th>
                                      <td mat-cell *matCellDef="let row">
                                        <div class="financial_mobtab">
                                          <div class="financial_valueName">
                                            <span>{{"financialDashboard.invoicenolabel" | cxTranslate}}</span>
                                            <p>{{ row.invoiceNumber }}</p>
                                          </div>
                                          <div class="financial_valueName">
                                            <span>{{"financialDashboard.statuslabel" | cxTranslate}}</span>
                                            <p>{{ row.status }}</p>
                                          </div>
                                          <div class="financial_valueName">
                                            <span>{{"financialDashboard.remainingBaltxt" | cxTranslate}}</span>
                                            <p>${{ row.amountDue | number : "1.2-2" }}</p>
                                          </div>
                                          <div class="financial_valueName">
                                            <span>{{"financialDashboard.totalinvcostlabel" | cxTranslate}}</span>
                                            <p>{{ row.amount | number : "1.2-2" }}</p>
                                          </div>
                                          <div class="financial_valueName">
                                            <span>{{"financialDashboard.invoiceDate" | cxTranslate}}</span>
                                            <p>{{ row.invoiceDate }}</p>
                                          </div>
                                          <div class="financial_valueName">
                                            <span>{{"financialDashboard.dueDate" | cxTranslate}}</span>
                                            <p>{{ row.dueDate }}</p>
                                          </div>
                                          <div class="financial_invoicearrow anchorunderline">
                                            <a
                                              class="anchorlink"
                                              [routerLink]="'/financial-dashboard/all-invoices'"
                        [queryParams]="{
                          invoice: row.invoiceNumber,
                          season: viewingseason
                        }"
                                              ><span>{{"financialDashboard.viewinvoice" | cxTranslate}}</span>
                                              <div class="global_blackarrow"></div
                                              ></a>
                                            </div>
                                          </div>
                                        </td>
                                      </ng-container>
                                      <tr mat-header-row *matHeaderRowDef="displayedmobColumns"></tr>
                                      <tr
                                        mat-row
                                        id="{{ row.invoiceNumber }}"
                                        *matRowDef="let row; columns: displayedmobColumns"
                                      ></tr>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!--  paid section start here -->
                            <div
                              class="col-xs-12 col-sm-12 col-lg-12 col-md-12 opensection"
                              [ngClass]="paidinvoiceflag ? 'open' : ''"
                              >
                              <div
                                class="col-sm-12 d-md-block d-lg-block d-none financial_alert-msg financial_alert-msgOpen"
                                [innerHtml]="financialresponse?.paidInvoicesText"
                              ></div>
                              <div
                                class="col-xs-12 col-sm-12 financial_invoicetable"
                                id="financial_invoicetable1"
                                >
                                <div
                                  class="financial_invoicetableheader col-xs-12 col-sm-12 col-md-12 col-lg-5"
                                  >
                                  {{"financialDashboard.paidinvoicetitle" | cxTranslate}}
                                </div>
                                <!-- total invoice changes -->
                                <div
                                  class="financial_dropdown margin-B20 d-none d-md-block d-lg-block"
                                  [ngClass]="toggleseason ? 'open' : ''"
                                  >
                                  <!-- total invoice changes -->
                                  <div class="button" (click)="openseason()">
                                    <!-- <span *ngIf="financialresponse?.currentSelectedSeason;else defaultseason"> -->
                                    <span class="seasonyear">{{ viewingseason }}&nbsp;{{"financialDashboard.invoicetitle" | cxTranslate}} </span>
                                  </div>
                                  <ul class="select-list" [ngClass]="toggleseason ? 'open' : ''">
                                    @for (season of financialresponse?.overdueinvoiceseason; track season) {
                                      <li
                                        class="clsAnchor"
                                        >
                                        @if (viewingseason != season.key) {
                                          <span class="seasonyear" (click)="seasonchangeclick(season.key)"
                                            >{{ season.key }}&nbsp;{{"financialDashboard.invoicetitle" | cxTranslate}}
                                          </span>
                                        }
                                      </li>
                                    }
                                  </ul>
                                </div>
                                <!-- total invoice changes -->
                                <div class="financial_invoicetabledetail">
                                  <div class="financial_invoicetabledetail1">
                                    <div
                                      class="col-xs-12 col-sm-12 ck-button no-padding"
              [ngClass]="
                financialresponse?.seqirusFinancialDashboardData?.statuses
                  .paid == 0
                  ? 'inactive_status'
                  : ''
              "
                                      >
                                      <label>
                                        <input
                                          type="checkbox"
                                          class="status"
                                          name="name"
                                          value="Paid"
                                          />
                                          <span
                                            class="financial_invoiceunpaidNo financial_invoiceNo call_status"
                                            >{{
                                            financialresponse?.seqirusFinancialDashboardData?.statuses
                                            .paid | number : "2.0-0"
                                            }}</span
                                            >
                                            <span class="financial_invoiceunpaidText">{{"financialDashboard.paidtxt" | cxTranslate}}</span>
                                          </label>
                                        </div>
                                      </div>
                                      @if (paiddata.data.length > 0) {
                                        <div
                                          class="financial_invoicetabledetail2 d-none d-md-block d-lg-block"
                                          >
                                          <table
                                            mat-table
                                            [dataSource]="paiddata"
                                            class="mat-elevation-z8 financial_table paidtable"
                                            >
                                            <ng-container matColumnDef="invoiceNumber">
                                              <th mat-header-cell *matHeaderCellDef>{{"financialDashboard.invoicenolabel" | cxTranslate}}</th>
                                              <td mat-cell *matCellDef="let row">{{ row.invoiceNumber }}</td>
                                            </ng-container>
                                            <ng-container matColumnDef="status">
                                              <th mat-header-cell *matHeaderCellDef>{{"financialDashboard.statuslabel" | cxTranslate}}</th>
                                              <td mat-cell *matCellDef="let row">{{ row.status }}</td>
                                            </ng-container>
                                            <ng-container matColumnDef="amount">
                                              <th mat-header-cell *matHeaderCellDef>{{"financialDashboard.totalinvcostlabel" | cxTranslate}}</th>
                                              <td mat-cell *matCellDef="let row">
                                                ${{ row.amount | number : "1.2-2" }}
                                              </td>
                                            </ng-container>
                                            <ng-container matColumnDef="clearingDate">
                                              <th mat-header-cell *matHeaderCellDef>{{"financialDashboard.datepaidlabel" | cxTranslate}}</th>
                                              <td mat-cell *matCellDef="let row">{{ row.clearingDate }}</td>
                                            </ng-container>
                                            <ng-container matColumnDef="selected">
                                              <th mat-header-cell *matHeaderCellDef></th>
                                              <td mat-cell *matCellDef="let row">
                                                <a
                                                  class="anchorlink"
                                                  [routerLink]="'/financial-dashboard/all-invoices'"
                    [queryParams]="{
                      invoice: row.invoiceNumber,
                      season: viewingseason
                    }"
                                                  ><span>{{"financialDashboard.viewinvoice" | cxTranslate}}</span>
                                                  <div class="global_blackarrow"></div
                                                  ></a>
                                                </td>
                                              </ng-container>
                                              <!-- Header and Row Declarations -->
                                              <tr mat-header-row *matHeaderRowDef="paidcolumn"></tr>
                                              <tr
                                                mat-row
                                                id="{{ row.invoiceNumber }}"
                                                *matRowDef="let row; columns: paidcolumn"
                                              ></tr>
                                            </table>
                                          </div>
                                        }
                                        <!-- moblie table for invoice start's here -->
                                        <div
                                          class="financial_invoicetabledetail2 d-md-none d-lg-none financial_openinvoiceMobiletable-1"
                                          >
                                          <table
                                            mat-table
                                            [dataSource]="paiddata"
                                            class="mat-elevation-z8 financial_table"
                                            >
                                            <ng-container matColumnDef="combined">
                                              <th
                                                class="odertableheader d-none"
                                                mat-header-cell
                                                *matHeaderCellDef
                                                >
                                                order Data
                                              </th>
                                              <td mat-cell *matCellDef="let row">
                                                <div class="financial_mobtab">
                                                  <div class="financial_valueName">
                                                    <span>{{"financialDashboard.invoicenolabel" | cxTranslate}}</span>
                                                    <p>{{ row.invoiceNumber }}</p>
                                                  </div>
                                                  <div class="financial_valueName">
                                                    <span>{{"financialDashboard.statuslabel" | cxTranslate}}</span>
                                                    <p>{{ row.status }}</p>
                                                  </div>
                                                  <div class="financial_valueName">
                                                    <span>{{"financialDashboard.totalinvcostlabel" | cxTranslate}} </span>
                                                    <p>${{ row.amount | number : "1.2-2" }}</p>
                                                  </div>
                                                  <div class="financial_valueName">
                                                    <span>{{"financialDashboard.datepaidlabel" | cxTranslate}}</span>
                                                    <p>{{ row.clearingDate }}</p>
                                                  </div>
                                                  <div class="financial_invoicearrow">
                                                    <a
                                                      class="anchorlink"
                                                      [routerLink]="'/financial-dashboard/all-invoices'"
                        [queryParams]="{
                          invoice: row.invoiceNumber,
                          season: viewingseason
                        }"
                                                      ><span>{{"financialDashboard.viewinvoice" | cxTranslate}}</span>
                                                      <div class="global_blackarrow"></div
                                                      ></a>
                                                    </div>
                                                  </div>
                                                </td>
                                              </ng-container>
                                              <tr mat-header-row *matHeaderRowDef="displayedmobColumns"></tr>
                                              <tr
                                                mat-row
                                                id="{{ row.invoiceNumber }}"
                                                *matRowDef="let row; columns: displayedmobColumns"
                                              ></tr>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <!--  paid section end's here -->
                                    <!-- all invoice link section -->
                                    <div class="col-xs-12 col-sm-12 mobpadding">
                                      <div class="col-xs-12 col-sm-12 financial_allinvoice">
                                        <div class="financial_allinvoiceClick" id="financial_allinvoiceClick1">
                                          <a
                                            class="anchorlink"
                                            [routerLink]="'/financial-dashboard/all-invoices'"
                                            >
                                            <span>{{"financialDashboard.viewallinv" | cxTranslate}}</span>
                                            <div class="global_blackarrow"></div>
                                          </a>
                                        </div>
                                      </div>
                                      <div
                                        class="col-xs-12 col-sm-12 financial_headerparent no-padding margin-T20"
                                        >
                                        <div
                                          class="col-xs-12 col-sm-12 no-padding financial_invoiceheader margin-T20"
                                          >
                                          {{"financialDashboard.creditinfotxt" | cxTranslate}}
                                        </div>
                                      </div>
                                      <div
                                        class="col-xs-12 col-sm-12 financial_invoicebtns financial_creditbtns mobile_credits"
                                        >
                                        <div
                                          class="financial_creditbtn active"
                                          id="financial_creditbtn-1"
                                          (click)="opencredit(1)"
                                          >
                                          <div class="financial_invoicebtnheader">{{"financialDashboard.availablecredit" | cxTranslate}}</div>
                                        </div>
                                        <!--pending credit button added-->
                                        <div
                                          class="financial_creditbtn"
                                          id="financial_creditbtn-2"
                                          (click)="opencredit(2)"
                                          >
                                          <div class="financial_invoicebtnheader">
                                            {{"financialDashboard.creditpendingtxt" | cxTranslate}}
                                          </div>
                                        </div>
                                        <div
                                          class="financial_creditbtn lastcreditbtn"
                                          id="financial_creditbtn-3"
                                          (click)="opencredit(3)"
                                          >
                                          <div class="financial_invoicebtnheader">{{"financialDashboard.creditapplied" | cxTranslate}}</div>
                                        </div>
                                      </div>
                                      <!-- avaiable credit -->
                                      <div
                                        class="col-xs-12 col-sm-12 financial_credittable open"
                                        id="financial_credittable1"
                                        >
                                        <div class="financial_totalbox float_left">
                                          <div class="financial_creditheader floatleft">
                                            <div class="financial_creditheaderText">
                                              {{"financialDashboard.totalavailablecredit" | cxTranslate}}
                                              <span class="financial_creditavail"
                                                >${{
                                                financialresponse?.seqirusFinancialDashboardData?.credit
                                                .totalAvailableCredit | number : "1.2-2"
                                                }}</span
                                                >
                                              </div>
                                              <div
                                                class="financial_creditheaderTooltip"
                                                id="financial_creditheaderTooltip-1"
                                                >
                                                <span (click)="tooltipopen($event)"
                                                  >{{"financialDashboard.availablecredittootlip" | cxTranslate}}</span
                                                  >
                                                  <div class="financial_triangle hide"></div>
                                                  <div class="messagetooltip hide" appRouterlinkinterceptor [innerHTML]="'financialDashboard.availablecredittootliptext' | cxTranslate">
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="financial_viewandManage d-none d-lg-block">
                                                <!-- mobile changes for apply credit-->
                                                <a
                                                  class="anchorlink"
                                                  [routerLink]="'/financial-dashboard/all-invoices'"
                                                  >
                                                  <span>{{"financialDashboard.view_manage_invoice" | cxTranslate}}</span>
                                                  <div class="global_blackarrow"></div>
                                                </a>
                                              </div>
                                            </div>
                                            <div
                                              class="financial_locationsearch financial_locationsearch-1 financial_LocationSearch_Hide">
                                              <div class="input-group seach_order">
                                                <div class="input-group-addon"><i class="fa fa-search"></i></div>
                                                <input
                                                  type="text"
                                                  placeholder="Search, filter, or sort your orders"
                                                  id="financial_locationsearch-1"
                                                  class="financial_Searchinput"
                                                  (keyup)="applyFilter($event, 'available')"
                                                  />
                                                </div>
                                              </div>
                                              <div class="financial_creditabledetail1 credittablebox float_left">
                                                @if (creditDataArray?.length > 0) {
                                                  <div
                                                    class="financial_locationsearch financial_locationsearch-2"
                                                    >
                                                    <div class="input-group seach_order">
                                                      <div class="input-group-addon"><i class="fa fa-search"></i></div>
                                                      <input
                                                        type="text"
                                                        placeholder="Search, filter, or sort your orders"
                                                        class="financial_Searchinput"
                                                        (keyup)="applyFilter($event, 'available')"
                                                        />
                                                      </div>
                                                    </div>
                                                  }
                                                  <div
                                                    class="financial_viewandManage d-lg-none d-sm-block col-sm-12 no-padding"
                                                    >
                                                    <!-- mobile changes for apply credit-->
                                                    <a
                                                      class="anchorlink"
                                                      [routerLink]="'/financial-dashboard/all-invoices'"
                                                      >
                                                      <span>{{"financialDashboard.view_manage_invoice" | cxTranslate}}</span>
                                                      <div class="global_blackarrow"></div>
                                                    </a>
                                                  </div>
                                                  @if (creditDataArray?.length > 0 && dataTableTab === 1) {
                                                    <div class="invoice_Financial_Credit_Table">
                                                      <app-invoice-financial-credit-table
                                                        [invoices]="creditDataArray"
                                                        [dataTable]="dataTableTab"
                                                        (downloadInvoice)="financialgetDownloadInvoiceData($event)"
                                                        />
                                                      </div>
                                                    }
                                                  </div>
                                                  <table
                                                    class="mobcredittable d-md-none d-lg-none"
                                                    mat-table
                                                    [dataSource]="creditavaible"
                                                    >
                                                    <ng-container matColumnDef="combined">
                                                      <th
                                                        class="odertableheader d-none"
                                                        mat-header-cell
                                                        *matHeaderCellDef
                                                        >
                                                        order Data
                                                      </th>
                                                      <td mat-cell *matCellDef="let row">
                                                        <div class="financial_mobtab">
                                                          <div class="billing">{{"financialDashboard.billing_heading" | cxTranslate}}</div>
                                                          <div class="billingvalue">{{ row.billTo.billingAddress }}</div>
                                                          <div class="financial_valueName">
                                                            <span> {{"financialDashboard.date_issue_heading" | cxTranslate}}</span>
                                                            <p>{{ row.invoiceDate }}</p>
                                                          </div>
                                                          <div class="financial_valueName">
                                                            <span>{{"financialDashboard.credit_Note_heading" | cxTranslate}}</span>
                                                            <p>${{ row.invoiceNumber }}</p>
                                                          </div>
                                                          <div class="financial_valueName">
                                                            <span>{{"financialDashboard.creditamnttxt" | cxTranslate}}</span>
                                                            <p>{{ row.formattedAmountWithTax }}</p>
                                                          </div>
                                                          <div class="financial_invoicearrow">
                                                            <a
                                                              class="anchorlink"
                                                              (click)="financialgetDownloadInvoiceData(row.invoiceNumber)"
                                                              ><span class="anchorunderline">{{"financialDashboard.view_Report" | cxTranslate}}</span>
                                                              <div class="global_blackarrow"></div
                                                              ></a>
                                                            </div>
                                                          </div>
                                                        </td>
                                                      </ng-container>
                                                      <tr mat-header-row *matHeaderRowDef="displayedmobColumns"></tr>
                                                      <tr
                                                        mat-row
                                                        id="{{ row.invoiceNumber }}"
                                                        *matRowDef="let row; columns: displayedmobColumns"
                                                      ></tr>
                                                    </table>
                                                  </div>
                                                  <!-- pending credit -->
                                                  <div
                                                    class="col-xs-12 col-sm-12 financial_credittable"
                                                    id="financial_credittable2"
                                                    >
                                                    <div class="financial_totalbox float_left">
                                                      <div class="financial_creditheader floatleft">
                                                        <div class="financial_creditheaderText">
                                                          {{"financialDashboard.totalcreditpending" | cxTranslate}}
                                                          <span class="financial_creditavail"
                                                            >${{
                                                            financialresponse?.seqirusFinancialDashboardData?.credit
                                                            .totalPendingCredit | number : "1.2-2"
                                                            }}</span
                                                            >
                                                          </div>
                                                          <div
                                                            class="financial_creditheaderTooltip"
                                                            id="financial_creditheaderTooltip-1"
                                                            >
                                                            <span (click)="tooltipopen($event)"
                                                              >{{"financialDashboard.creditpendingtooltip" | cxTranslate}}</span
                                                              >
                                                              <div class="financial_triangle hide"></div>
                                                              <div class="messagetooltip hide" [innerHTML]="'financialDashboard.creditpendingtooltiptext' | cxTranslate">
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div class="financial_viewandManage d-none d-md-block d-lg-block">
                                                            <!-- mobile changes for apply credit-->
                                                            <a
                                                              class="anchorlink"
                                                              [routerLink]="'/financial-dashboard/all-invoices'"
                                                              target="_self"
                                                              >
                                                              <span>{{"financialDashboard.view_manage_invoice" | cxTranslate}}</span>
                                                              <div class="global_blackarrow"></div>
                                                            </a>
                                                          </div>
                                                        </div>
                                                        <div
                                                          class="financial_locationsearch financial_locationsearch-1 financial_LocationSearch_Hide">
                                                          <div class="input-group seach_order">
                                                            <div class="input-group-addon"><i class="fa fa-search"></i></div>
                                                            <input
                                                              type="text"
                                                              placeholder="Search, filter, or sort your orders"
                                                              id="financial_locationsearch-1"
                                                              class="financial_Searchinput"
                                                              (keyup)="applyFilter($event, 'pending')"
                                                              />
                                                            </div>
                                                          </div>
                                                          <div class="financial_creditabledetail1 credittablebox float_left">
                                                            @if (pendingDataArray?.length > 0) {
                                                              <div
                                                                class="financial_locationsearch financial_locationsearch-2"
                                                                >
                                                                <div class="input-group seach_order">
                                                                  <div class="input-group-addon"><i class="fa fa-search"></i></div>
                                                                  <input
                                                                    type="text"
                                                                    placeholder="Search, filter, or sort your orders"
                                                                    class="financial_Searchinput"
                                                                    (keyup)="applyFilter($event, 'pending')"
                                                                    />
                                                                  </div>
                                                                </div>
                                                              }
                                                              <div
                                                                class="financial_viewandManage d-md-none d-lg-none d-sm-block col-sm-12 no-padding"
                                                                >
                                                                <!-- mobile changes for apply credit-->
                                                                <a
                                                                  class="anchorlink"
                                                                  [routerLink]="'/financial-dashboard/all-invoices'"
                                                                  >
                                                                  <span>{{"financialDashboard.view_manage_invoice" | cxTranslate}}</span>
                                                                  <div class="global_blackarrow"></div>
                                                                </a>
                                                              </div>
                                                              @if (pendingDataArray?.length > 0 && dataTableTab === 2) {
                                                                <div>
                                                                  <app-invoice-financial-credit-table
                                                                    [invoices]="pendingDataArray"
                                                                    [dataTable]="dataTableTab"
                                                                    (downloadInvoice)="financialgetDownloadInvoiceData($event)"
                                                                    />
                                                                  </div>
                                                                }
                                                              </div>
                                                              <table
                                                                class="mobcredittable d-md-none d-lg-none"
                                                                mat-table
                                                                [dataSource]="pending"
                                                                >
                                                                <ng-container matColumnDef="combined">
                                                                  <th
                                                                    class="odertableheader d-none"
                                                                    mat-header-cell
                                                                    *matHeaderCellDef
                                                                    >
                                                                    order Data
                                                                  </th>
                                                                  <td mat-cell *matCellDef="let row">
                                                                    <div class="financial_mobtab">
                                                                      <div class="billing">{{"financialDashboard.billing_heading" | cxTranslate}}</div>
                                                                      <div class="billingvalue">{{ row.billTo.billingAddress }}</div>
                                                                      <div class="financial_valueName">
                                                                        <span>{{"financialDashboard.date_issue_heading" | cxTranslate}}</span>
                                                                        <p>{{ row.invoiceDate }}</p>
                                                                      </div>
                                                                      <div class="financial_valueName">
                                                                        <span>{{"financialDashboard.credit_Note_heading" | cxTranslate}}</span>
                                                                        <p>${{ row.invoiceNumber }}</p>
                                                                      </div>
                                                                      <div class="financial_valueName">
                                                                        <span>{{"financialDashboard.creditamnttxt" | cxTranslate}}</span>
                                                                        <p>{{ row.formattedAmountWithTax }}</p>
                                                                      </div>
                                                                      <div class="financial_invoicearrow">
                                                                        <a
                                                                          class="anchorlink"
                                                                          (click)="financialgetDownloadInvoiceData(row.invoiceNumber)"
                                                                          ><span class="anchorunderline">{{"financialDashboard.view_Report" | cxTranslate}}</span>
                                                                          <div class="global_blackarrow"></div
                                                                          ></a>
                                                                        </div>
                                                                      </div>
                                                                    </td>
                                                                  </ng-container>
                                                                  <tr mat-header-row *matHeaderRowDef="displayedmobColumns"></tr>
                                                                  <tr
                                                                    mat-row
                                                                    id="{{ row.invoiceNumber }}"
                                                                    *matRowDef="let row; columns: displayedmobColumns"
                                                                  ></tr>
                                                                </table>
                                                              </div>
                                                              <!-- applied credit -->
                                                              <div
                                                                class="col-xs-12 col-sm-12 financial_credittable"
                                                                id="financial_credittable3"
                                                                >
                                                                <div class="financial_totalbox float_left">
                                                                  <div class="financial_creditheader floatleft">
                                                                    <div class="financial_creditheaderText">
                                                                      {{"financialDashboard.totalusedcredit" | cxTranslate}}
                                                                      <span class="financial_creditavail"
                                                                        >${{
                                                                        financialresponse?.seqirusFinancialDashboardData?.credit
                                                                        .totalUsedCredit | number : "1.2-2"
                                                                        }}</span
                                                                        >
                                                                      </div>
                                                                      <div
                                                                        class="financial_creditheaderTooltip"
                                                                        id="financial_creditheaderTooltip-1"
                                                                        >
                                                                        <span (click)="tooltipopen($event)"
                                                                          >{{"financialDashboard.usedcredittooltip" | cxTranslate}}</span
                                                                          >
                                                                          <div class="financial_triangle hide"></div>
                                                                          <div class="messagetooltip hide" [innerHTML]="'financialDashboard.usedcredittooltiptext' | cxTranslate">
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                      <div class="financial_viewandManage d-none d-md-block d-lg-block">
                                                                        <!-- mobile changes for apply credit-->
                                                                        <a
                                                                          class="anchorlink"
                                                                          [routerLink]="'/financial-dashboard/all-invoices'"
                                                                          target="_self"
                                                                          >
                                                                          <span>{{"financialDashboard.view_manage_invoice" | cxTranslate}}</span>
                                                                          <div class="global_blackarrow"></div>
                                                                        </a>
                                                                      </div>
                                                                    </div>
                                                                    <div
                                                                      class="financial_locationsearch financial_locationsearch-1 financial_LocationSearch_Hide">
                                                                      <div class="input-group seach_order">
                                                                        <div class="input-group-addon"><i class="fa fa-search"></i></div>
                                                                        <input
                                                                          type="text"
                                                                          placeholder="Search, filter, or sort your orders"
                                                                          id="financial_locationsearch-1"
                                                                          class="financial_Searchinput"
                                                                          (keyup)="applyFilter($event, 'applied')"
                                                                          />
                                                                        </div>
                                                                      </div>
                                                                      <div class="financial_creditabledetail1 credittablebox float_left">
                                                                        @if (appliedDataArray?.length > 0) {
                                                                          <div
                                                                            class="financial_locationsearch financial_locationsearch-2"
                                                                            >
                                                                            <div class="input-group seach_order">
                                                                              <div class="input-group-addon"><i class="fa fa-search"></i></div>
                                                                              <input
                                                                                type="text"
                                                                                placeholder="Search, filter, or sort your orders"
                                                                                class="financial_Searchinput"
                                                                                (keyup)="applyFilter($event, 'applied')"
                                                                                />
                                                                              </div>
                                                                            </div>
                                                                          }
                                                                          <div
                                                                            class="financial_viewandManage d-md-none d-lg-none d-sm-block col-sm-12 no-padding"
                                                                            >
                                                                            <!-- mobile changes for apply credit-->
                                                                            <a
                                                                              class="anchorunderline"
                                                                              [routerLink]="'/financial-dashboard/all-invoices'"
                                                                              >
                                                                              <span>{{"financialDashboard.view_manage_invoice" | cxTranslate}}</span>
                                                                              <div class="global_blackarrow"></div>
                                                                            </a>
                                                                          </div>
                                                                          @if (appliedDataArray?.length > 0 &&  dataTableTab === 3) {
                                                                            <div>
                                                                              <app-invoice-financial-credit-table
                                                                                [invoices]="appliedDataArray"
                                                                                [dataTable]="dataTableTab"
                                                                                (downloadInvoice)="financialgetDownloadInvoiceData($event)"
                                                                                />
                                                                              </div>
                                                                            }
                                                                          </div>
                                                                          <table
                                                                            class="mobcredittable d-md-none d-lg-none"
                                                                            mat-table
                                                                            [dataSource]="applied"
                                                                            >
                                                                            <ng-container matColumnDef="combined">
                                                                              <th
                                                                                class="odertableheader d-none"
                                                                                mat-header-cell
                                                                                *matHeaderCellDef
                                                                                >
                                                                                order Data
                                                                              </th>
                                                                              <td mat-cell *matCellDef="let row">
                                                                                <div class="financial_mobtab">
                                                                                  <div class="billing">{{"financialDashboard.billing_heading" | cxTranslate}}</div>
                                                                                  <div class="billingvalue">{{ row.billTo.billingAddress }}</div>
                                                                                  <div class="financial_valueName">
                                                                                    <span> {{"financialDashboard.date_issue_heading" | cxTranslate}}</span>
                                                                                    <p>{{ row.invoiceDate }}</p>
                                                                                  </div>
                                                                                  <div class="financial_valueName">
                                                                                    <span>{{"financialDashboard.credit_Note_heading" | cxTranslate}}</span>
                                                                                    <p>${{ row.invoiceNumber }}</p>
                                                                                  </div>
                                                                                  <div class="financial_valueName">
                                                                                    <span>{{"financialDashboard.creditamnttxt" | cxTranslate}}</span>
                                                                                    <p>{{ row.formattedAmountWithTax }}</p>
                                                                                  </div>
                                                                                  <div class="financial_invoicearrow">
                                                                                    <a
                                                                                      class="anchorlink"
                                                                                      (click)="financialgetDownloadInvoiceData(row.invoiceNumber)"
                                                                                      ><span class="anchorunderline">{{"financialDashboard.view_Report" | cxTranslate}}</span>
                                                                                      <div class="global_blackarrow"></div
                                                                                      ></a>
                                                                                    </div>
                                                                                  </div>
                                                                                </td>
                                                                              </ng-container>
                                                                              <tr mat-header-row *matHeaderRowDef="displayedmobColumns"></tr>
                                                                              <tr
                                                                                mat-row
                                                                                id="{{ row.invoiceNumber }}"
                                                                                *matRowDef="let row; columns: displayedmobColumns"
                                                                              ></tr>
                                                                            </table>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    }
                                                                  </section>
